import { create } from "zustand";

export const useRifaStore = create((set) => ({
  solicitud: null,
  precio:'0',

  setPrecio:(precio)=>{
    set({precio:precio})
  },

  setSolicitud: (solicitud) =>{
    set({solicitud:solicitud})
  },


}));
